import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import getitemaction from "../../context/action/item/getitemaction";
import { MdDeleteForever } from "react-icons/md";
import createaction from "../../context/action/buy/createaction";
import numberbeautify from "../../utils/numberbeautify";

const Buy = () => {
  const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);

  const [company_invoice_type, setcompany_invoice_type] = useState("cash");
  const [company_invoice_date, setcompany_invoice_date] = useState();
  const [company_invoice_number, setcompany_invoice_number] = useState();
  const [company_invoice_note, setcompany_invoice_note] = useState();
  const [company_id, setcompany_id] = useState("null");
  const [user_id, setuser_id] = useState();
  const [items, setitems] = useState([]);
  const [text, settext] = useState();

  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);
  const [error2, seterror2] = useState(false);
  const [error3, seterror3] = useState(false);

  const changeval = (index, prop, value) => {};

  return (
    <div className="min-h-screen bg-slate-50 p-6 md:p-8">
      {/* Page Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">کڕین</h1>
          <p className="text-sm text-slate-400 mt-0.5">ناساندنی پسوڵەی کڕدراو</p>
        </div>
      </div>
      {/* Add New Expense Form */}
      <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-4 items-end">
        <div className="w-full">
          <label
            htmlFor="cate"
            className={
              "block text-sm font-medium text-slate-500 mb-1 text-right"
            }>
            جۆری وەسڵ
          </label>
          <select
            className="w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            value={company_invoice_type}
            onChange={(val) => setcompany_invoice_type(val.target.value)}
          >
            <option value="cash">کاش</option>
            <option value="loan">قەرز</option>
          </select>
        </div>

        {/* Invoice Date */}
        <div className="w-full">
          <label
            className={
              error1
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
          >
            بەرواری وەسڵ
          </label>
          <input
            type="date"
            className={
              error1
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            value={company_invoice_date}
            onChange={(val) => setcompany_invoice_date(val.target.value)}
            onFocus={() => seterror1(false)}
          />
        </div>

        {/* Invoice Number */}
        <div className="w-full">
          <label
            className={
              error2
              ? "block text-sm font-medium text-red-500 mb-1 text-right"
              : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
          >
            ژمارەی وەسڵ
          </label>
          <input
            type="text"
            className={
              error2
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            value={company_invoice_number}
            onClick={(val) => val.target.select()}
            onChange={(val) => setcompany_invoice_number(val.target.value)}
            onFocus={() => seterror2(false)}
          />
        </div>

        {/* Invoice Note */}
        <div className="w-full">
          <label className="block text-sm font-medium text-slate-500 mb-1 text-right">
            تێبینی
          </label>
          <input
            type="text"
            className="w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            value={company_invoice_note}
            onClick={(val) => val.target.select()}
            onChange={(val) => setcompany_invoice_note(val.target.value)}
          />
        </div>

        {/* Company Select */}
        <div className="w-full">
          <label
            className={
              error3
                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                : "block text-sm font-medium text-slate-500 mb-1 text-right"
            }
          >
            کۆمپانیای دابینکەر
          </label>
          <select
            className={
              error3
                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
            }
            value={company_id}
            onChange={(val) => {
              setcompany_id(val.target.value);
              seterror3(false);
            }}
          >
            <option value="null">کۆمپانیا</option>
            {initState.company.map((lis) => (
              <option key={lis.company_id} value={lis.company_id}>
                {lis.company_name}
              </option>
            ))}
          </select>
        </div>

        {/* Add Invoice Button */}
        <div className="w-full">
          <button
            className={items.length > 0
                ? "h-12 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
                : "h-12 px-6 bg-indigo-300 hover:bg-indigo-400 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"}
            disabled={!items.length}
            onClick={() => {
              if (company_invoice_date == "" || !company_invoice_date) {
                seterror1(true);
                return false;
              }
              if (company_invoice_number == "" || !company_invoice_number) {
                seterror2(true);
                return false;
              }
              if (company_id == "null" || !company_id) {
                seterror3(true);
                return false;
              }
              console.log("steeep one");
              
              if ((items.filter((lis) => lis.company_invoice_item_qty <= 0).length > 0)||(items.filter((lis) => lis.company_invoice_item_price <= 0).length > 0)) {
                alert("کێشە لە (نرخی کڕین یا عەدەد)ی یەکێک لە کاڵاکان هەیە.");
                return false;
              }
              createaction(
                company_invoice_type,
                company_invoice_date,
                company_invoice_note,
                company_invoice_number,
                company_id,
                initState.token.id,
                items
              )(recaller)(setrecaller)(initDispatch)(clear);
            }}
          >
            زیادکردنی وەسڵ
          </button>
        </div>
      </div>
      </div>

      {/* Item Search Section */}
      <div className="bg-gray-400 border border-gray-500 rounded-xl p-6 mb-6 shadow-sm">
        <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-4 items-end">
          <div className="w-full">
            <label
              className={
                "block text-base font-medium text-white mb-1 text-right"
              }
              htmlFor="item_name"
            >
              ناوی ئایتم / باڕکۆد
            </label>
            <input
              type="text"
              className="w-full h-12 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
              value={text}
              onClick={(val) => val.target.select()}
              onChange={(val) => settext(val.target.value)}
              onKeyDown={(key) => {
                if (key.key === "Enter") {
                  if(items.filter((lis) => (lis.item_barcode == text||lis.item_name == text)).length > 0){
                    alert("ئەم کاڵایە پێشتر زیادکراوە");
                    return false;
                  } else{
                    getitemaction(text)(recaller)(setrecaller)(items)(setitems)(
                      settext
                    );
                  }
                }
              }}
            />
          </div>
          <div className="w-full">
            <button
              className="h-12 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
              onClick={() => {
                if(items.filter((lis) => (lis.item_barcode == text||lis.item_name == text)).length > 0){
                    alert("ئەم کاڵایە پێشتر زیادکراوە");
                    return false;
                  } else{
                    getitemaction(text)(recaller)(setrecaller)(items)(setitems)(
                      settext
                    );
                  }
              }}
            >
              ئایتم
            </button>
          </div>
        </div>
      </div>

      {/* Items Table */}
      {items.length > 0 && (
        <>
        <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-slate-50 border-b border-slate-100">
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    ناوی کاڵا
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    باڕکۆد
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    نرخی کڕین
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    عەدەد
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    بەرواری بەسەرچوون
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                    ڕەشکردنەوە
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-50">
                {items.map((lis, index) => (
                  <tr
                    key={index}
                    className="hover:bg-slate-50 transition-colors duration-100 cursor-pointer"
                  >
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      {lis.item_name}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      {lis.item_barcode}
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      <input
                        className="w-[120px] lg:w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                        id="grid-last-name"
                        type="number"
                        value={lis.company_invoice_item_price}
                        onClick={(val) => {
                          val.target.select();
                        }}
                        onChange={(val) => {
                          setitems(
                            items.map((lis, indexx) =>
                              index == indexx
                                ? {
                                    item_id: lis.item_id,
                                    item_name: lis.item_name,
                                    item_barcode: lis.item_barcode,
                                    company_invoice_item_qty:
                                      lis.company_invoice_item_qty,
                                    company_invoice_item_price:
                                      val.target.value,
                                    company_invoice_item_exp_date:
                                      lis.company_invoice_item_exp_date,
                                  }
                                : lis
                            )
                          );
                        }}
                      />
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      <input
                        className="w-[120px] lg:w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                        id="grid-last-name"
                        type="number"
                        value={lis.company_invoice_item_qty}
                        onClick={(val) => {
                          val.target.select();
                        }}
                        onChange={(val) => {
                          setitems(
                            items.map((lis, indexx) =>
                              index == indexx
                                ? {
                                    item_id: lis.item_id,
                                    item_name: lis.item_name,
                                    item_barcode: lis.item_barcode,
                                    company_invoice_item_qty:
                                      val.target.value,
                                    company_invoice_item_price:
                                      lis.company_invoice_item_price,
                                    company_invoice_item_exp_date:
                                      lis.company_invoice_item_exp_date,
                                  }
                                : lis
                            )
                          );
                        }}
                      />
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      <input
                        className="w-[120px] lg:w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                        id="grid-last-name"
                        type="date"
                        value={lis.company_invoice_item_exp_date}
                        onChange={(val) => {
                          setitems(
                            items.map((lis, indexx) =>
                              index == indexx
                                ? {
                                    item_id: lis.item_id,
                                    item_name: lis.item_name,
                                    item_barcode: lis.item_barcode,
                                    company_invoice_item_qty:
                                      lis.company_invoice_item_qty,
                                    company_invoice_item_price:
                                      lis.company_invoice_item_price,
                                    company_invoice_item_exp_date:
                                      val.target.value,
                                  }
                                : lis
                            )
                          );
                        }}
                      />
                    </td>
                    <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      <MdDeleteForever
                        size={28}
                        color="#e74c3c"
                        className="cursor-pointer mx-auto"
                        onClick={() => {
                          setitems(
                            items.filter((list) => list.item_id != lis.item_id)
                          );
                        }}
                      />
                    </td>
                  </tr>
                ))}
                <tr className="bg-slate-50 border-b border-slate-100">
                  <th
                    className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide"
                    colSpan={4}
                  >
                    کۆی گشتی
                  </th>
                  <td 
                    className="px-6 py-4 text-sm font-medium text-slate-800 text-right"
                    colSpan={2}
                  >
                    {numberbeautify(
                      items.reduce(
                        (a, v) =>
                          (a =
                            Number(a) +
                            Number(v.company_invoice_item_price) * Number(v.company_invoice_item_qty)),
                        0
                      )
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default Buy;
